<!-- <template>
   <div class="animated fadeUp conainer">
      <div class="create-form-section">
        <div class="login-form Verify-page bg-dot-img">
            <div class="login-leftbox">
                <img src="../assets/images/login-left-img.png">
                <h3>A one stop solution to digitize all your Control your finances, assets & liabilities.</h3>
            </div>
            <div class="login-right-box">
              <div class="form-box">
                <div class="logo-img">
                  <img src="../assets/images/logo.png" />
                </div>
                <h4>OTP</h4>
                <b-form @submit.prevent="handleSubmit">
                   <b-row>
                      <b-col lg="12" md="12">
                        <b-form-group id="input-group-1" label='*OTP sent on registered Email' label-for="input-1">
                            <b-form-input id="input-1" v-model="user.confirmationCode" type="text" placeholder='Enter OTP' name="confirmationCode" :class="{ 'is-invalid': submitted && $v.user.confirmationCode.$error }"></b-form-input>
                            <div v-if="submitted && $v.user.confirmationCode.$error" class="invalid-feedback">
                              <span v-if="!$v.user.confirmationCode.required">OTP is required</span>
                            </div>
                            <div  class="invalid-feedback" id="invalid_otp" style="display:none;">
                              <span>Invalid OTP</span>
                            </div>
                        </b-form-group>
                      </b-col>
                   </b-row>
                   <div class="form-button">
                      <b-button type="submit" variant="secondary" class="blue-btn verify-btn">Verify OTP</b-button>
                   </div>
                </b-form>
             </div>
            </div>
        </div>
      </div>
   </div>
</template>
<script>
    import axios from 'axios';
    import { required} from "vuelidate/lib/validators";
    import { Auth } from 'aws-amplify';
    export default {
        name: "app",
        data() {
            return {
                user: {
                  confirmationCode: ""
                },
                submitted: false
            };
        },
        validations: {
            user: {
              confirmationCode:  {required}
            }
        },
        methods: {
            handleSubmit(e) {
              this.submitted = true;
              this.$v.$touch();
              if (this.$v.$invalid) {
                return;
              }
              let code      = this.user.confirmationCode;
              let username  = localStorage.getItem("email");
              let password  = localStorage.getItem("password");
              let mobile_no = localStorage.getItem("mobile_no"); 
              const confirmSignUp = Auth.confirmSignUp(username,code).then(data => {
              const signIn   = Auth.signIn(username, password).then(data => {
                  var data = JSON.stringify({"mobile_no":'+91'+mobile_no,"aws_cognito_id":localStorage.getItem("cognito_idp")});
                  console.log(data);

                  var config = {
                    method: 'post',
                    url: 'http://dev-api.nimeya.ai/api/send-otp',
                    headers: { 
                      'Content-Type': 'application/json'
                    },
                    data : data
                  };
                  axios(config)
                  .then(function (response) {
                         
                  })
                  .catch(function (error) {
                    console.log(error);
                  });  
              })
              .catch(err =>console.log(signIn));
              this.$router.push({ name: 'VerifyMobileOtp' }).catch(()=>{}); 
              })
              .catch(function (error) {
                  document.getElementById('invalid_otp').style.display = 'block';
              });
            }
        }
    };
</script>
 -->

<template>
   <v-container class="login-container">
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
        <LoginImageComponent />
      </v-col>
      <v-col
          cols="12"
          md="6"
        >
        <OtpForRegister />
      </v-col>
    </v-row>
  </v-container>
 </template>
 <script>
  import LoginImageComponent from './common/LoginImageComponent.vue';
  import OtpForRegister from './Register/OtpForRegister.vue';
   export default {
  //name: 'App',
  components: {
       LoginImageComponent,
       OtpForRegister,
      },
  data: () => ({
    //
  }),
  /*computed: {
       isPublic() {
           return this.$route.meta.isPublic ? true : false;
       }
   },*/
  methods: {
  }
};
 </script>